export interface CourtStaff {
  courtId: number | null;
  prtId: string | null;
  prtName: string | null;
  stpId: number | null;
  stpName: string | null;
  userName: string | null;
  intUserId: number | null;
  password: string | null;
  pwdValidUntil: number | null;
  userActiveUntil: number | string |null;
  languageCode: number | null;
  languageName: string | null;
  status: string | null;

  staffAbsencesData: StaffAbsence[] | null;
  staffAssignmentsData: StaffAssignment[] | null;
  tasksData: any[] | null;
  caseData: any[] | null;
  chargeClaimsData: any[] | null;

  activeRole: string | null;
  activeStaffAssignment: string | null;

  roleAssignmentsData: RoleAssignment[] | null;

  auditMessage: string | null;
  isAddMode?:boolean |null;
  isEditMode?:boolean |null;
}

export interface StaffAssignment {
  courtId: number | null;
  prtId: string | null;
  beginDate: number | string |null;
  endDate: number | null;
  courtUnitId: number | string;
  courtUnitName: string;
  courtUnitTypeId?: number | null;
  pctCases: number | null;
  status: string | null;
  courtsId: number | null;
  courtsName: string | null;
  auditMessage?: string;
  isEdit?:boolean
}

export interface RoleAssignment {
  courtstaffdata_id?: any;
  roleBeginDate: number | string |null ;
  roleEndDate: number | null;
  intRoleId: number;
  roleName: string;
  status: string | null;
  courtId: number | null;
  roleLevelId: number;
  isEdit?:boolean
}
export interface StaffAbsence {
  courtId: number;
  absenceTypeId: number |string;
  absenceTypeName: string;
  absenceTypeDesc: string;
  sabFrom: number | string |null; // Unix timestamp
  sabTo: number |string |null;   // Unix timestamp
  prtId: string;
  status: string | null;
  activeFlag: 'Y' | 'N';
  auditMessage?: string;
  isEdit?:boolean;
  isModify?:boolean;
  selectedAbsenceType?:any
}
export interface CourtsForRole {
  courtId: number;
  partyId: number | null;
  partyName: string;
  courtLevelsId: number | null;
  courtLevelName: string | null;
  adminUnitsId: number | null;
  adminUnitsName: string | null;
  geoJurisLevelsId: number | null;
  geoJurisLevelsName: string | null;
  locationCode: string | null;
  supremeCourtId: number | null;
  supremeCourtName: string | null;
  appealingCourtId: number | null;
  appealingCourtName: string | null;
  transType: string | null;
  courtUnitsData: any[] | null; // Replace any if you have a CourtUnit interface
  municipalityJurisditionData: any[] | null;
  courtStaffData: CourtStaff[] | null; // Link to the model created earlier
  facilitiesData: any[] | null;
  courtType: string | null;
  auditMessage: string;
}

export interface Courts {
  courtId: number;
  name: string;
  courtStaffData: CourtStaff[] | null; // Link to the model created earlier
  auditMessage: string;
}

export interface CustomTtRoleDtlsDTO {
  intRoleId: number;
  roleName: string;
  transType: string | null;
  reportFlag: string | null;
  rcaCode: number;
  roleLevelId: number;
  divisionId: number | null;
  cutId: number | null;
  roleShortName: string | null;
  courtId: number | null;
  auditMessage: string;
}

export interface ICourtUnitType {
    courtUnitTypeId: number | string;
    courtUnitTypeName: string;
    courtUnitTypeShortName: string;
    hearingDate: string | null;
    courtUnitId: string | null;
    courtUnitName: string | null;
    auditMessage: string;
}

export interface StaffAbsencesTypes {
  courtId: number | null;
  absenceTypeId: number;
  absenceTypeName: string;
  absenceTypeDesc: string;
  sabFrom: Date | string | null;
  sabTo: Date | string | null;
  prtId: number | null;
  status: string | null;
  activeFlag: string | null;
  auditMessage: string;
}
export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MMM-YYYY',
  },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};